/**
 * Utilitaires de sanitization pour prévenir les attaques XSS
 */
import DOMPurify from 'dompurify';

/**
 * Sanitize une chaîne de caractères pour prévenir XSS
 * @param {string} text - Texte à sanitizer
 * @returns {string} Texte sanitizé
 */
export function sanitizeText(text) {
  if (!text || typeof text !== 'string') {
    return '';
  }
  // DOMPurify.sanitize pour les chaînes de texte
  return DOMPurify.sanitize(text, { ALLOWED_TAGS: [] }); // Pas de tags HTML autorisés
}

/**
 * Sanitize une URL pour prévenir les attaques (javascript:, data:, etc.)
 * @param {string} url - URL à valider
 * @returns {string|null} URL sécurisée ou null si invalide
 */
export function sanitizeUrl(url) {
  if (!url || typeof url !== 'string') {
    return null;
  }
  
  const trimmedUrl = url.trim();
  
  // Bloquer les schémas dangereux
  const dangerousSchemes = ['javascript:', 'data:', 'vbscript:', 'file:', 'about:'];
  const lowerUrl = trimmedUrl.toLowerCase();
  
  for (const scheme of dangerousSchemes) {
    if (lowerUrl.startsWith(scheme)) {
      return null;
    }
  }
  
  // Autoriser seulement http:// et https://
  if (!trimmedUrl.startsWith('http://') && !trimmedUrl.startsWith('https://')) {
    return null;
  }
  
  return trimmedUrl;
}

/**
 * Sanitize du HTML (si nécessaire pour l'affichage)
 * @param {string} html - HTML à sanitizer
 * @returns {string} HTML sanitizé
 */
export function sanitizeHtml(html) {
  if (!html || typeof html !== 'string') {
    return '';
  }
  // DOMPurify.sanitize avec configuration par défaut (sécurisée)
  return DOMPurify.sanitize(html);
}

/**
 * Valide et sanitize un nom de produit
 * @param {string} name - Nom du produit
 * @returns {string} Nom sanitizé
 */
export function sanitizeProductName(name) {
  if (!name || typeof name !== 'string') {
    return '';
  }
  // Enlever les tags HTML et limiter la longueur
  const sanitized = DOMPurify.sanitize(name, { ALLOWED_TAGS: [] });
  return sanitized.substring(0, 200); // Limite de 200 caractères
}

